"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mobileDeviceFromUserAgent = void 0;
const tslib_1 = require("tslib");
const ua_parser_js_1 = tslib_1.__importDefault(require("ua-parser-js"));
const UA = new ua_parser_js_1.default();
const device = UA.getDevice();
const Android = () => /Android/iu.test(navigator.userAgent);
const BlackBerry = () => /BlackBerry/iu.test(navigator.userAgent);
const iOS = () => /iP(?:hone|od|ad)/iu.test(navigator.userAgent) ||
    // to detect iPadOS > 13:
    (/Mac/u.test(navigator.platform) && 'ontouchstart' in document);
const Opera = () => /Opera Mini/iu.test(navigator.userAgent);
const Windows = () => /IEMobile|WPDesktop/iu.test(navigator.userAgent);
const any = () => Boolean(Android() ||
    BlackBerry() ||
    iOS() ||
    Opera() ||
    Windows() ||
    device.type === 'mobile' ||
    device.type === 'tablet');
exports.mobileDeviceFromUserAgent = {
    Android,
    any,
    BlackBerry,
    iOS,
    Opera,
    Windows,
};
//# sourceMappingURL=index.js.map